
import React from 'react';
import { SolutionDataWithId } from '../types';
import Button from './Button';
import ShareSection from './ShareSection';
import SolutionDisplay from './SolutionDisplay';
import  QuestionMarkCircleIcon  from './icons/QuestionMarkCircleIcon';
import { useTranslation } from 'react-i18next';

interface ResultsViewProps {
  solution: SolutionDataWithId;
  onSolveAnother: () => void;
}

const ResultsView: React.FC<ResultsViewProps> = ({ solution, onSolveAnother }) => {
  const { t } = useTranslation();
  const { solution_jsonb } = solution;

  const hasSolutions = solution_jsonb?.math_solutions && solution_jsonb.math_solutions.length > 0 && solution_jsonb.math_solutions[0]?.image_is_math_problem !== 'no';

  if (!hasSolutions) {
    return (
      <div className="bg-white p-4 sm:p-6 md:p-8 shadow-xl rounded-lg text-center">
        <QuestionMarkCircleIcon className="w-16 h-16 text-slate-400 mx-auto mb-4" />
        <h2 className="text-2xl md:text-3xl font-bold text-sky-700 mb-4">{t('resultsView.notAMathProblem')}</h2>
        <p className="text-slate-600 mb-8">{t('resultsView.notAMathProblemDescription')}</p>
        <Button onClick={onSolveAnother} size="lg">
          {t('resultsView.tryAnotherImage')}
        </Button>
      </div>
    );
  }

  const solutionCount = solution_jsonb.math_solutions.length;
  const title = t('resultsView.solutionTitle', { count: solutionCount });

  return (
    <div className="bg-white p-4 sm:p-6 md:p-8 shadow-xl rounded-lg">
      <div id="printable-solution-content">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-sky-700 mb-8 print:text-black">{title}</h2>
        <SolutionDisplay solution={solution} />
      </div>

      <ShareSection solutionId={solution.id} className="mt-8" />

      <div className="text-center mt-10 print:hidden">
        <Button onClick={onSolveAnother} size="lg" variant="secondary">
          {t('resultsView.solveNewProblem')}
        </Button>
      </div>
    </div>
  );
};

export default ResultsView;